import { useState } from "react";
import { Link } from "react-router-dom";

export default function FallWinterSignature({
  title       = "Fall / Winter Signature",
  description = "Lorem ipsum dolor sit amet consectetur. Et lectus quam rhoncus enim nec ultrices blandit. Habitasse ultrices aliquet nisi amet vestibulum id. Et massa diam pharetra sollicitudin ultrices penatibus fringilla sagittis. Ante nulla egestas tellus laoreet adipiscing neque leo egestas.",
  imageSrc    = "/fall_winter.png",
  imageAlt    = "Fall Winter Signature Collection",
}) {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <section className="w-full mt-10 sm:mt-16 lg:mt-[130px] flex flex-col items-center bg-white overflow-hidden">

      {/* ── Heading block ── */}
      <div className="w-full text-center px-6 pt-6 sm:pt-16 pb-4">

        {/* title */}
        <h2
          className="uppercase text-[#2c2520] m-0 mb-5"
          style={{
            fontFamily: "'Githera Regular', sans-serif",
            fontSize: "clamp(20px, 1.875vw, 36px)",
            fontWeight: 400,
            lineHeight: "38px",
            letterSpacing: "0",
          }}
        >
          {title}
        </h2>

        {/* body copy */}
        <p
          className="text-[#000] max-w-[940px] mx-auto text-center"
          style={{ fontFamily: "Roboto, sans-serif", fontWeight: 300, fontSize: "clamp(12px, 0.9375vw, 18px)", lineHeight: "32px" }}
        >
          {description}
        </p>
      </div>


      {/* ── Image ── */}
      <div
        className="w-full max-w-[1100px] px-4 pt-4"
        style={{ aspectRatio: "1 / 1" }}
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          onLoad={() => setImgLoaded(true)}
          className="w-full h-full object-cover object-top"
          style={{ opacity: imgLoaded ? 1 : 0, transition: "opacity 0.6s ease" }}
        />
      </div>

      {/* ── Discover more ── */}
      <div className="pb-12 lg:pb-32">
        <Link
          to="/category/women"
          className="text-[#2c2520] hover:opacity-60 transition-opacity underline underline-offset-4 decoration-[#2c2520]/40 hover:decoration-[#2c2520]"
          style={{
            fontFamily: "Roboto, sans-serif",
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: "32px",
            letterSpacing: "0",
          }}
        >
          Discover more →
        </Link>
      </div>

    </section>
  );
}